import React, { Component } from 'react';
import {
  Link
} from 'react-router-dom';
import { Svgs } from '../components/Svgs';

class NoMatch extends Component {
  render() {
    return (
      <div className="nothing-found">
        <p>Nothing here sorry.</p>
        <Link to="/" className="btn">Back to the start <Svgs width="8" height="8" svg="RightChevron" /></Link>
      </div>
    );
  }
}

export default NoMatch;



// WEBPACK FOOTER //
// ./src/screens/NoMatch.js